// import React, { useEffect, useState, useContext } from "react";
// import { Button, Form } from "react-bootstrap";
// import Nav from "react-bootstrap/Nav";
// import Navbar from "react-bootstrap/Navbar";
// import { Link, useNavigate } from "react-router-dom";
// import Badge from "react-bootstrap/Badge";
// import jwt_decode from "jwt-decode";
// import schoolApi from "../../../api/schoolApi";
// import Draggable from "react-draggable";
// import "../../../App.css";
// import { SessionContext } from "../../SessionProvider";
// import Confirm from "../../Confirm"

// const Header = ({ allLauncherData, setAllLauncherData }) => {
//   const navigate = useNavigate();
//   const [userInfo, setUserInfo] = useState({});
//   const [sessionYear, setSessionYear] = useState([]);
//   const { selectedSessionId, setSelectedSessionId } = 
//     useContext(SessionContext);
//   console.log("selectedSessionId@!@=>", selectedSessionId);
//   const [sessionModal, setSessionModal] = useState(false);
//   //const [reload, setReload] = useState(false);
//   const [updateSession, setUpdateSession] = useState(false);

//   useEffect(() => {
//     async function init() {
//       if (!sessionStorage.getItem("token")) navigate("/login");
//       try {
//         if (sessionStorage.getItem("token")) {
//           let user = jwt_decode(sessionStorage.getItem("token"));
//           setUserInfo(user);
//         }
//         const sessions = await schoolApi.fetchSessions();
//         console.log("sessionsa=>", sessions);
//         if (sessions.success) {
//           setSessionYear(sessions.result);
//         }
//       } catch (error) { }
//     }
//     init();
//   }, []);

//   useEffect(() => {
//     schoolApi.getAllQuickLauncher().then((result) => {
//       if (result?.success) {
//         setAllLauncherData(result.records);
//       } else {
//         setAllLauncherData([]);
//       }
//     });
//   }, []);

//   const [sidebar, setSidebar] = useState(false);
//   const logout = () => {
//     navigate("/login");
//     sessionStorage.removeItem("token");
//   };

//   const toggleSidebar = () => {
//     if (sidebar === false) {
//       setSidebar(true);
//       document.querySelector("#sidebar").classList.toggle("active");
//     } else {
//       setSidebar(false);
//       document.querySelector("#sidebar").classList.toggle("active");
//     }
//   };

//   const [open_Ql, setopen_Ql] = useState(false);
//   const QuickLauncher = () => {
//     setopen_Ql(!open_Ql);
//   };

//   // const handleSession = (e) => {
//   //   console.log("e.target.value@@+>", e.target.value);
//   //   setSelectedSessionId(e.target.value);
//   // };


//   const handleSession = (e) => {
//     setUpdateSession(e.target.value)
//     // handleChangeSession();
//     setSessionModal(true);
//   };

//   const ChangeSession = async () => {
//     setSelectedSessionId(updateSession);
//     setSessionModal(false);
//   };

//   return (
//     <>
//       {sessionModal && (
//         <Confirm
//           show={sessionModal}
//           onHide={() => setSessionModal(false)}
//           ChangeSession={ChangeSession}
//           title="Confirm Change?"
//           message="You are going to update the session. Are you sure?"
//           table="header_session"
//         />
//       )}
//       <Navbar className="header px-2 mt-1" bg="" expand="lg" variant="">
//         <button
//           type="button"
//           id="sidebarCollapse"
//           className="btn btn-primary"
//           onClick={toggleSidebar}
//         >
//           <i className="fa fa-align-left"></i>
//         </button>
//         <Navbar.Brand href="#home"></Navbar.Brand>
//         <Navbar.Toggle aria-controls="basic-navbar-nav" />
//         <Navbar.Collapse id="basic-navbar-nav">

//           <Nav className="me-auto">
//             <Nav.Link href="#" className="p-0" style={{ fontSize: ".9rem" }}>
//               <img
//                 src={sessionStorage.getItem("myimage")}
//                 className="rounded-circle"
//                 style={{ height: "30px" }}
//                 alt=""
//               />
//             </Nav.Link>

//             <Nav.Link href="#" className="p-0" style={{ fontSize: ".9rem" }}>
//               { }
//               <img
//                 className="rounded-circle"
//                 id="profileimage"
//                 style={{ height: "30px" }}
//                 alt=""
//               />
//               <Badge style={{ fontSize: ".9rem" }} bg="light" text="dark">
//                 {userInfo.firstname} {userInfo.lastname}
//               </Badge>
//               <Badge
//                 bg="success"
//                 style={{
//                   fontSize: ".9rem",
//                   paddingTop: "7px",
//                   paddingBottom: "4px",
//                   paddingLeft: "12px",
//                   paddingRight: "12px",
//                 }}
//               >
//                 {userInfo.userrole}
//               </Badge>
//             </Nav.Link>
//             <Nav.Link
//               href="#"
//               className="d-flex p-0"
//               style={{ alignItems: "center" }}
//             >
//               <span className="mx-2" style={{ fontSize: ".9rem" }}>
//                 School
//               </span>{" "}
//               <Badge
//                 style={{
//                   fontSize: ".9rem",
//                   paddingTop: "7px",
//                   paddingBottom: "4px",
//                   paddingLeft: "12px",
//                   paddingRight: "12px",
//                 }}
//                 bg="secondary"
//               >
//                 {userInfo.companyname}
//               </Badge>{" "}
//             </Nav.Link>
//             <Nav.Link
//               href="#"
//               className="d-flex p-0"
//               style={{ alignItems: "center" }}
//             >
//               <span className="mx-2" style={{ fontSize: ".9rem" }}>
//                 Session
//               </span>{" "}
//               <Form.Group className="mx-2">
//                 <Form.Select
//                   name="sessionid"
//                   value={selectedSessionId}
//                   onChange={handleSession}
//                 >
//                   {sessionYear.map((session) => (
//                     <option key={session.id} value={session.id}>
//                       {session.year}
//                     </option>
//                   ))}
//                 </Form.Select>
//               </Form.Group>
//             </Nav.Link>
//           </Nav>
//           <Form.Control type="text" style={{ width: '300px' }} />

//           <Nav className="ml-auto">
//             <Nav.Link href="/about">
//               <i className="fa-solid fa-bell"></i>
//             </Nav.Link>
//             {sessionStorage.getItem("token") ? (
//               <Button variant="btn btn-primary" onClick={logout} title="Logout">
//                 <i className="fa-solid fa-right-from-bracket"></i>
//               </Button>
//             ) : (
//               <></>
//             )}
//           </Nav>
//         </Navbar.Collapse>
//       </Navbar>

//       { }
//       {allLauncherData.length > 0 && (
//         <Draggable
//           className="text-dark"
//           bounds={{ left: -1300, top: -540, right: 10, bottom: 20 }}
//         >
//           <div
//             style={{
//               position: "fixed",
//               zIndex: 1000,
//               bottom: 20,
//               right: 10,
//             }}
//           >
//             <button
//               type="button"
//               style={{
//                 position: "fixed",
//                 background: "#c5597d",
//                 height: "50px",
//                 width: "50px",
//                 borderRadius: "100%",
//                 border: "1px ",
//               }}
//               className="btn btn-secondary appLauncher px-2"
//               onClick={() => QuickLauncher()}
//             >
//               <i id="dragIcon" className="fa-solid fa-jet-fighter-up"></i>
//             </button>
//             {open_Ql && (
//               <div className="all_Quick_launcher ">
//                 {allLauncherData?.map((vl, ky) => (
//                   <div className="card  bg-light">
//                     <Link
//                       className="card-body text-decoration-none"
//                       to={vl.sub_module_url}
//                       state={{ [vl?.name]: true }}
//                       data-toggle="tooltip"
//                       data-placement="left"
//                       title={vl?.name}
//                     >
//                       <i className={vl.icon} />
//                     </Link>
//                   </div>
//                 ))}
//               </div>
//             )}
//           </div>
//         </Draggable>
//       )}
//     </>
//   );
// };

// export default Header;


import React, { useEffect, useState, useContext, useRef } from "react";
import { Button, Form } from "react-bootstrap";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { Link, useNavigate } from "react-router-dom";
import Badge from "react-bootstrap/Badge";
import jwt_decode from "jwt-decode";
import schoolApi from "../../../api/schoolApi";
import Draggable from "react-draggable";
import "../../../App.css";
import { SessionContext } from "../../SessionProvider";
import Confirm from "../../Confirm"

const Header = ({ allLauncherData, setAllLauncherData }) => {
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useState({});
  const [sessionYear, setSessionYear] = useState([]);
  const { selectedSessionId, setSelectedSessionId } =
    useContext(SessionContext);
  console.log("selectedSessionId@!@=>", selectedSessionId);
  const [sessionModal, setSessionModal] = useState(false);
  const [updateSession, setUpdateSession] = useState(false);

  // Student search states
  const [searchTerm, setSearchTerm] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [searchLoading, setSearchLoading] = useState(false);

  // Notification states
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [showNotifDropdown, setShowNotifDropdown] = useState(false);
  const notifRef = useRef(null);

  // Close notification dropdown when clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (notifRef.current && !notifRef.current.contains(event.target)) {
        setShowNotifDropdown(false);
      }
    };

    if (showNotifDropdown) {
      document.addEventListener("mousedown", handleClickOutside);
      document.addEventListener("touchstart", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [showNotifDropdown]);

  useEffect(() => {
    async function init() {
      if (!sessionStorage.getItem("token")) navigate("/login");
      console.log("heare");

      try {
        if (sessionStorage.getItem("token")) {
          let user = jwt_decode(sessionStorage.getItem("token"));
          setUserInfo(user);
        }
        const sessions = await schoolApi.fetchSessions();
        console.log("sessionsa=>", sessions);
        if (sessions.success) {
          setSessionYear(sessions.result);
        }
      } catch (error) { }
    }
    init();
    fetchNotificationsData();
  }, []);

  const fetchNotificationsData = async () => {
    try {
      if (sessionStorage.getItem("token")) {
        const user = jwt_decode(sessionStorage.getItem("token"));
        const [notifRes, countRes] = await Promise.all([
          schoolApi.fetchNotifications(user.id),
          schoolApi.fetchUnreadCount(user.id)
        ]);

        if (notifRes.success) setNotifications(notifRes.result);
        if (countRes.success) setUnreadCount(countRes.count ?? countRes.result ?? 0);
      }
    } catch (error) {
      console.error("Error fetching notifications:", error);
    }
  };

  useEffect(() => {
    const interval = setInterval(fetchNotificationsData, 60000); // Poll every 60s
    const handleNotificationRefresh = () => {
      fetchNotificationsData();
    };
    window.addEventListener("refreshNotifications", handleNotificationRefresh);
    window.addEventListener("taskDeleted", handleNotificationRefresh);
    return () => {
      clearInterval(interval);
      window.removeEventListener("refreshNotifications", handleNotificationRefresh);
      window.removeEventListener("taskDeleted", handleNotificationRefresh);
    };
  }, []);

  const formatNotifTime = (timestamp) => {
    if (!timestamp) return "";
    const date = new Date(timestamp);
    if (isNaN(date.getTime())) return "";

    const now = new Date();
    const isToday = date.toDateString() === now.toDateString();

    const yesterday = new Date(now);
    yesterday.setDate(now.getDate() - 1);
    const isYesterday = date.toDateString() === yesterday.toDateString();

    const timeStr = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

    if (isToday) {
      return timeStr;
    }
    if (isYesterday) {
      return `Yesterday, ${timeStr}`;
    }
    return `${date.toLocaleDateString([], { month: 'short', day: 'numeric' })}, ${timeStr}`;
  };

  const unreadNotifications = (notifications || []).filter((notif) => !notif.is_read);

  const handleNotificationClick = async (notif) => {
    try {
      // Optimistically mark as read so it disappears from the unread list
      setNotifications((prev) =>
        prev.map((n) => (n.id === notif.id ? { ...n, is_read: true } : n))
      );
      setUnreadCount((prev) => Math.max(0, prev - 1));

      // mark single notification read
      await schoolApi.markNotificationRead(notif.id);
      setShowNotifDropdown(false);
      // refresh count and data from server
      await fetchNotificationsData();
      if (notif.reference_id) {
        if (notif.type && notif.type.startsWith('task_')) {
          navigate(`/tasks/view/${notif.reference_id}`);
        } else if (notif.type === 'announcement') {
          navigate(`/announcements`);
        } else if (notif.type === 'exam_scheduled' || notif.type === 'exam_updated') {
          navigate(`/examscheduleview/${notif.reference_id}`);
        } else {
          navigate(`/assignment/${notif.reference_id}`);
        }
      } else if (notif.type === 'announcement') {
        navigate(`/announcements`);
      }
    } catch (error) {
      console.error("Error marking notification as read:", error);
    }
  };

  const markAllAsRead = async () => {
    try {
      // Optimistically clear the unread notifications list immediately
      setNotifications((prev) => prev.map((n) => ({ ...n, is_read: true })));
      setUnreadCount(0);

      const user = jwt_decode(sessionStorage.getItem("token"));
      await schoolApi.markAllNotificationsRead(user.id);
      await fetchNotificationsData();
    } catch (error) {
      console.error("Error marking all as read:", error);
    }
  };

  useEffect(() => {
    schoolApi.getAllQuickLauncher().then((result) => {
      if (result?.success) {
        setAllLauncherData(result.records);
      } else {
        setAllLauncherData([]);
      }
    });
  }, []);

  useEffect(() => {
    setSearchTerm("");
    setSuggestions([]);
    setShowSuggestions(false);
    setSearchLoading(false);
  }, [selectedSessionId]);

  // Student search effect
  useEffect(() => {
    if (!searchTerm || !searchTerm.trim() || !selectedSessionId) {
      setSuggestions([]);
      setSearchLoading(false);
      return;
    }

    const delayDebounce = setTimeout(async () => {
      setSearchLoading(true);
      try {
        const response = await schoolApi.searchStudents({
          sessionId: selectedSessionId,
          search: searchTerm.trim()
        });
        console.log("Search response:", response);
        if (response?.success && Array.isArray(response.result)) {
          const seen = new Set();
          const uniqueList = [];
          for (const s of response.result) {
            const idKey = s.student_id || s.studentid || s.id;
            const rollKey = (s.srno || "").trim().toLowerCase();
            const nameKey = (s.student_name || `${s.firstname || ''} ${s.lastname || ''}`).trim().toLowerCase();
            const combinedKey = rollKey ? `${rollKey}_${nameKey}` : idKey;

            if (!seen.has(idKey) && !seen.has(combinedKey)) {
              seen.add(idKey);
              seen.add(combinedKey);
              uniqueList.push(s);
            }
          }
          setSuggestions(uniqueList);
        } else {
          setSuggestions([]);
        }
      } catch (error) {
        console.error("Search error:", error);
        setSuggestions([]);
      } finally {
        setSearchLoading(false);
      }
    }, 300);

    return () => clearTimeout(delayDebounce);
  }, [searchTerm, selectedSessionId]);

  const [sidebar, setSidebar] = useState(false);
  const logout = () => {
    navigate("/login");
    sessionStorage.removeItem("token");
  };

  const toggleSidebar = () => {
    if (sidebar === false) {
      setSidebar(true);
      document.querySelector("#sidebar").classList.toggle("active");
    } else {
      setSidebar(false);
      document.querySelector("#sidebar").classList.toggle("active");
    }
  };

  const [open_Ql, setopen_Ql] = useState(false);
  const QuickLauncher = () => {
    setopen_Ql(!open_Ql);
  };

  const handleSession = (e) => {
    setUpdateSession(e.target.value)
    setSessionModal(true);
  };

  const ChangeSession = async () => {
    setSelectedSessionId(updateSession);
    setSessionModal(false);
  };

  // Handle student click
  const handleStudentClick = (student) => {
    console.log("student", student);

    setSearchTerm("");
    setSuggestions([]);
    setShowSuggestions(false);

    console.log("hear", student);
    navigate(`/studentaddmissions/${student.id}`, {
      state: {
        student_info: {
          ...student,
          id: student.studentid || student.student_id,
          studentid: student.studentid || student.student_id,
          student_addmission_id: student.id,
          studentname:
            student.student_name ||
            `${student.firstname || ""} ${student.lastname || ""}`.trim(),
          class_name: student.classname,
        },
      },
    });
  };

  return (
    <>
      {sessionModal && (
        <Confirm
          show={sessionModal}
          onHide={() => setSessionModal(false)}
          ChangeSession={ChangeSession}
          title="Confirm Change?"
          message="You are going to update the session. Are you sure?"
          table="header_session"
        />
      )}
      <Navbar className="header px-2 mt-1" bg="" expand="lg" variant="">
        <button
          type="button"
          id="sidebarCollapse"
          className="btn btn-primary"
          onClick={toggleSidebar}
        >
          <i className="fa fa-align-left"></i>
        </button>
        <Navbar.Brand href="#home"></Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">

          <Nav className="me-auto">
            <Nav.Link href="#" className="p-0" style={{ fontSize: ".9rem" }}>
              <img
                src={sessionStorage.getItem("myimage")}
                className="rounded-circle"
                style={{ height: "30px" }}
                alt=""
              />
            </Nav.Link>

            <Nav.Link href="#" className="p-0" style={{ fontSize: ".9rem" }}>
              <img
                className="rounded-circle"
                id="profileimage"
                style={{ height: "30px" }}
                alt=""
              />
              <Badge style={{ fontSize: ".9rem" }} bg="light" text="dark">
                {userInfo.firstname} {userInfo.lastname}
              </Badge>
              <Badge
                bg="success"
                style={{
                  fontSize: ".9rem",
                  paddingTop: "7px",
                  paddingBottom: "4px",
                  paddingLeft: "12px",
                  paddingRight: "12px",
                }}
              >
                {userInfo.userrole}
              </Badge>
            </Nav.Link>
            <Nav.Link
              href="#"
              className="d-flex p-0"
              style={{ alignItems: "center" }}
            >
              <span className="mx-2" style={{ fontSize: ".9rem" }}>
                School
              </span>{" "}
              <Badge
                style={{
                  fontSize: ".9rem",
                  paddingTop: "7px",
                  paddingBottom: "4px",
                  paddingLeft: "12px",
                  paddingRight: "12px",
                }}
                bg="secondary"
              >
                {userInfo.companyname}
              </Badge>{" "}
            </Nav.Link>
            <Nav.Link
              href="#"
              className="d-flex p-0"
              style={{ alignItems: "center" }}
            >
              <span className="mx-2" style={{ fontSize: ".9rem" }}>
                Session
              </span>{" "}
              <Form.Group className="mx-2">
                <Form.Select
                  name="sessionid"
                  value={selectedSessionId}
                  onChange={handleSession}
                >
                  {sessionYear.map((session) => (
                    <option key={session.id} value={session.id}>
                      {session.year}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Nav.Link>
          </Nav>

          {/* Updated Search Input with Suggestions */}
          <div style={{ position: "relative", width: "300px" }}>
            <Form.Control
              type="text"
              placeholder="🔍 Search student by name..."
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setShowSuggestions(true);
              }}
              onFocus={() => setShowSuggestions(true)}
              onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
              style={{ width: "100%" }}
            />

            {/* Loading Spinner */}
            {searchLoading && (
              <div style={{ position: "absolute", right: "10px", top: "8px" }}>
                <i className="fa-solid fa-spinner fa-spin"></i>
              </div>
            )}

            {showSuggestions && suggestions.length > 0 && (
              <div
                style={{
                  position: "absolute",
                  top: "100%",
                  left: 0,
                  right: 0,
                  backgroundColor: "white",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  maxHeight: "300px",
                  overflowY: "auto",
                  zIndex: 9999,
                  boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                }}
              >
                {suggestions.map((student) => (
                  <div
                    key={student.student_id || student.id}
                    onMouseDown={() => {
                      console.log("Selected student in onMouseDown:", student);
                      handleStudentClick(student);
                    }}
                    style={{
                      padding: "10px 15px",
                      cursor: "pointer",
                      borderBottom: "1px solid #eee",
                      transition: "background 0.2s",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.backgroundColor = "#f0f0f0")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.backgroundColor = "white")
                    }
                  >
                    <div>
                      <strong>{student.student_name || student.firstname} </strong>
                      <span style={{ marginLeft: "10px", fontSize: "12px", color: "#666" }}>
                        | Roll: {student.srno}
                      </span>
                      <span style={{ marginLeft: "10px", fontSize: "12px", color: "#666" }}>
                        | Class: {student.classname}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            )}

            {/* No Results */}
            {showSuggestions && searchTerm && !searchLoading && suggestions.length === 0 && (
              <div
                style={{
                  position: "absolute",
                  top: "100%",
                  left: 0,
                  right: 0,
                  backgroundColor: "white",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  padding: "10px",
                  textAlign: "center",
                  color: "#999",
                  zIndex: 9999,
                }}
              >
                No students found in this session
              </div>
            )}
          </div>

          <Nav className="ml-auto">
            {/* Notification Bell with Dropdown */}
            <div ref={notifRef} className="nav-item dropdown mx-2" style={{ position: 'relative' }}>
              <Nav.Link 
                href="#" 
                className="p-0 position-relative" 
                onClick={(e) => { 
                  e.preventDefault(); 
                  if (!showNotifDropdown) {
                    fetchNotificationsData();
                  }
                  setShowNotifDropdown(!showNotifDropdown); 
                }}
              >
                <i className="fa-solid fa-bell fs-5"></i>
                {unreadCount > 0 && (
                  <Badge 
                    pill 
                    bg="danger" 
                    className="position-absolute top-0 start-100 translate-middle"
                    style={{ fontSize: '0.6rem', padding: '0.25em 0.5em' }}
                  >
                    {unreadCount}
                  </Badge>
                )}
              </Nav.Link>

              {showNotifDropdown && (
                <div 
                  className="dropdown-menu dropdown-menu-end show shadow-lg border-0" 
                  style={{ 
                    position: 'absolute', 
                    top: '100%', 
                    right: 0, 
                    width: '320px', 
                    maxHeight: '450px', 
                    overflowY: 'auto',
                    zIndex: 1050,
                    borderRadius: '12px',
                    marginTop: '10px'
                  }}
                >
                  <div className="p-3 border-bottom d-flex justify-content-between align-items-center bg-light rounded-top">
                    <h6 className="mb-0 fw-bold">Notifications</h6>
                    {unreadNotifications.length > 0 && (
                      <button 
                        className="btn btn-link btn-sm p-0 text-decoration-none text-primary fw-semibold" 
                        onClick={markAllAsRead}
                        style={{ fontSize: '0.8rem' }}
                      >
                        Mark all as read
                      </button>
                    )}
                  </div>
                  <div className="list-group list-group-flush">
                    {unreadNotifications.length > 0 ? (
                      unreadNotifications.map((notif) => {
                        let displayTitle = notif.title;
                        let displayMessage = notif.message;
                        let taskStatus = notif.task_status;

                        if (notif.type && notif.type.startsWith('task_')) {
                          if (notif.task_title) {
                            displayTitle = notif.task_title;
                          } else if (notif.title === 'New Task Assigned' || notif.title === 'Task Updated') {
                            const match = (notif.message || '').match(/"([^"]+)"/);
                            if (match && match[1]) {
                              displayTitle = match[1];
                            }
                          }

                          if (notif.type === 'task_completed' || notif.message?.toLowerCase().includes('completed')) {
                            displayMessage = 'Task Completed';
                            if (!taskStatus) taskStatus = 'Completed';
                          } else if (notif.type === 'task_cancelled' || notif.message?.toLowerCase().includes('cancelled')) {
                            displayMessage = 'Task Cancelled';
                            if (!taskStatus) taskStatus = 'Cancelled';
                          } else if (notif.type === 'task_update' || notif.message?.toLowerCase().includes('updated')) {
                            displayMessage = 'Task Updated';
                          } else if (notif.type === 'task_assigned' || notif.message?.toLowerCase().includes('assigned')) {
                            displayMessage = 'You have been assigned a new task';
                            if (!taskStatus) taskStatus = 'Pending';
                          } else if (notif.type === 'task_approved') {
                            displayMessage = 'Task Approved';
                            if (!taskStatus) taskStatus = 'Approved';
                          } else if (notif.type === 'task_rejected') {
                            displayMessage = 'Task Rejected';
                            if (!taskStatus) taskStatus = 'Rejected';
                          }
                        } else if (notif.type === 'announcement') {
                          if (!taskStatus) taskStatus = 'Announcement';
                        }

                        const statusBadgeMap = {
                          'Pending': 'warning',
                          'In Progress': 'info',
                          'Submitted': 'primary',
                          'Completed': 'success',
                          'Approved': 'success',
                          'Rejected': 'danger',
                          'Cancelled': 'secondary',
                          'Announcement': 'primary'
                        };

                        const renderMessage = (msg) => {
                          if (!msg) return "";
                          
                          // Handle quoted text first (new pattern)
                          if (msg.includes('"')) {
                            const parts = msg.split(/("(?:[^"\\]|\\.)*")/);
                            return parts.map((part, i) => 
                              part.startsWith('"') && part.endsWith('"') 
                                ? <strong key={i} className="text-primary fw-bold" style={{ fontSize: '0.9rem' }}>{part.slice(1, -1)}</strong> 
                                : part
                            );
                          }
                          
                          // Handle colon-separated text (older pattern or fallbacks)
                          if (msg.includes(':')) {
                            const lastColonIndex = msg.lastIndexOf(':');
                            const before = msg.substring(0, lastColonIndex + 1);
                            const after = msg.substring(lastColonIndex + 1);
                            return (
                              <span>
                                {before} <strong className="text-primary fw-bold" style={{ fontSize: '0.9rem' }}>{after.trim()}</strong>
                              </span>
                            );
                          }
                          
                          return msg;
                        };

                        return (
                          <div 
                            key={notif.id} 
                            className="list-group-item list-group-item-action p-3 border-bottom"
                            style={{ cursor: 'pointer', transition: 'background 0.2s', backgroundColor: '#f0f7ff' }}
                            onClick={() => handleNotificationClick(notif)}
                          >
                            <div className="d-flex justify-content-between align-items-start mb-1">
                              <div className="d-flex align-items-center flex-wrap gap-2 me-2">
                                <span className="fw-bold small">{displayTitle}</span>
                                {taskStatus && (
                                  <Badge 
                                    bg={statusBadgeMap[taskStatus] || 'secondary'} 
                                    text={taskStatus === 'Pending' ? 'dark' : 'white'}
                                    className="fw-normal" 
                                    style={{ fontSize: '0.65rem', padding: '0.2em 0.55em', borderRadius: '4px' }}
                                  >
                                    {taskStatus}
                                  </Badge>
                                )}
                              </div>
                              <span 
                                className="text-muted" 
                                style={{ fontSize: '0.7rem', flexShrink: 0 }}
                                title={notif.created_at ? new Date(notif.created_at).toLocaleString() : ''}
                              >
                                {formatNotifTime(notif.created_at)}
                              </span>
                            </div>
                            <p className="mb-0 text-muted small" style={{ lineHeight: '1.4' }}>
                              {renderMessage(displayMessage)}
                            </p>
                            <div className="mt-2" style={{ height: '6px', width: '6px', backgroundColor: '#007bff', borderRadius: '50%' }}></div>
                          </div>
                        );
                      })
                    ) : (
                      <div className="p-5 text-center text-muted">
                        <i className="fa-regular fa-bell-slash d-block mb-2 fs-3 opacity-50"></i>
                        <small>No unread notifications</small>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>

            {sessionStorage.getItem("token") ? (
              <Button variant="btn btn-primary" onClick={logout} title="Logout">
                <i className="fa-solid fa-right-from-bracket"></i>
              </Button>
            ) : (
              <></>
            )}
          </Nav>
        </Navbar.Collapse>
      </Navbar>

      {/* Quick Launcher */}
      {allLauncherData.length > 0 && (
        <Draggable
          className="text-dark"
          bounds={{ left: -1300, top: -540, right: 10, bottom: 20 }}
        >
          <div
            style={{
              position: "fixed",
              zIndex: 1000,
              bottom: 20,
              right: 10,
            }}
          >
            <button
              type="button"
              style={{
                position: "fixed",
                background: "#c5597d",
                height: "50px",
                width: "50px",
                borderRadius: "100%",
                border: "1px ",
              }}
              className="btn btn-secondary appLauncher px-2"
              onClick={() => QuickLauncher()}
            >
              <i id="dragIcon" className="fa-solid fa-jet-fighter-up"></i>
            </button>
            {open_Ql && (
              <div className="all_Quick_launcher ">
                {allLauncherData?.map((vl, ky) => (
                  <div className="card  bg-light" key={ky}>
                    <Link
                      className="card-body text-decoration-none"
                      to={vl.sub_module_url}
                      state={{ [vl?.name]: true }}
                      data-toggle="tooltip"
                      data-placement="left"
                      title={vl?.name}
                    >
                      <i className={vl.icon} />
                    </Link>
                  </div>
                ))}
              </div>
            )}
          </div>
        </Draggable>
      )}
    </>
  );
};

export default Header;
